/**
 * defa.views.AlarmGroupErrorForm
 * An informative view of alarm group errors.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/alarmGroupErrorForm.jst.html';

const selectors           = {
	buttonRetest: '[data-click=group-error-retest]',
};
const AlarmGroupErrorForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		retest: selectors.buttonRetest,
	},
	
	events: {
		'click @ui.retest': 'onClickRetest',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onClickRetest: function () {
		this.trigger( 'retest' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default AlarmGroupErrorForm;